import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { runtimeEventManager } from "@wm/core";
import { PaginationModule } from "ngx-bootstrap/pagination";

@Component({
    selector: 'basicPagination',
    standalone: true,
    templateUrl: './basic-pagination.component.html',
    imports: [
        CommonModule,
        FormsModule,
        PaginationModule
    ]
})

//Basic Pagination UI, without any actions
export class BasicPagination {
    @Input() navigationAlign!: string;
    @Input() navigationType!: string;
    @Input() navigationSize!: string;
    @Input() currentPage!: any;
    @Input() showrecordcount!: boolean;
    @Input() dataset!: any;
    @Input() pageCount!: any;
    i18nService: any;
    appLocale: any;

    sizeClasses: any = {
        'Pager': {
            'small': 'pager-sm',
            'large': 'pager-lg'
        },
        'Basic': {
            'small': 'pagination-sm',
            'large': 'pagination-lg'
        },
        'Classic': {
            'small': 'pagination-sm',
            'large': 'pagination-lg'
        }
    };

    constructor() {
        this.i18nService = runtimeEventManager.getService('i18Services');
    }

    ngOnInit() {
        this.appLocale = this.i18nService.getMessages() || this.i18nService.appLocale;
        if(typeof this.dataset === 'string') {
            this.dataset = JSON.parse(this.dataset)
        }
    }
}

